import { Controller } from "@hotwired/stimulus"
import { createTachoChart } from "../charts/tacho/chart"

// Connects to data-controller="tacho-chart"
export default class extends Controller {
	static targets = ["state", "chart", "start", "running"]

	initialize() {
		this.chart = null
		this.verbunden = false
	}

	connect() {
		if (!this.hasChartTarget || !this.hasStartTarget || !this.hasRunningTarget) {
			console.error("Tacho Elemente nicht gefunden.")
			return
		}

		this.chart = createTachoChart(this.chartTarget)
		this.verbunden = true
		if (this.hasStateTarget) this.statusAnwenden(this.stateTarget)
	}

	disconnect() {
		this.verbunden = false
		this.chart?.destroy()
		this.chart = null
	}

	stateTargetConnected(element) {
		if (!this.verbunden) return

		this.statusAnwenden(element)
	}

	statusAnwenden(stateElement) {
		this.hideElements()

		switch (stateElement.dataset.status) {
			case "hidden":
				break
			case "berechnung":
				this.showRunning()
				break
			case "anzeigen":
				this.showChart(Number(stateElement.dataset.simulationserfolg))
				break
			case "neu_berechnen":
				this.showStart()
				break
		}
	}

	hideElements() {
		this.chartTarget.classList.add("hidden")
		this.startTarget.classList.add("hidden")
		this.runningTarget.classList.add("hidden")
	}

	showChart(simulationserfolg) {
		this.chartTarget.classList.remove("hidden")
		if (!this.chart) this.chart = createTachoChart(this.chartTarget)

		this.chart.update(simulationserfolg)
	}

	showStart() {
		this.startTarget.classList.remove("hidden")
	}

	showRunning() {
		this.runningTarget.textContent = "Simulation läuft"
		this.runningTarget.classList.remove("hidden")
	}
}
